<template>
    <div class="call-me-page hide-popup-by-click" @mousedown="handleHidePopup" style="position: fixed; z-index: 9999999; height: 100vh;
">
        <div class="call-me-page__form-wrapper">
            <!-- Форма -->
            <form action="" class="call-me-page-form" v-show="!isSuccess && !showSms">
                <div class="call-me-page-form__title like-h2">{{ formContent.formTitle }}</div>
                <p class="call-me-page-form__message">{{ formContent.formText }}</p>
                <!-- Поле ввода имени - блок -->
                <div class="call-me-page-form__name-input-container">
                    <input class="call-me-page-form__name-input" type="text" placeholder="Имя" v-model="nameValue">
                </div>
                <!-- Поле ввода номера телефона - блок -->
                <div class="call-me-page-form__telephone-input-container">
                    <input class="call-me-page-form__telephone-input" type="text" v-maska="'+7 (###) ### ## ##'"
                        v-model="telephoneNumberValue" @input="handlePhoneInput" @focusout="handleUnsetDefaultPhone"
                        @focusin="handleSetDefaultPhone" :placeholder="mask">
                    <p class="call-me-page-form__phone-error" v-if="isPhoneError">Введите номер телефона</p>
                </div>
                <div v-if="showCallTimeFields" class="application-form-calltime">
                    <div class="application-form-calltime__switch">
                        <button type="button" class="application-form-calltime__mode"
                            :class="{ 'application-form-calltime__mode_active': selectedCallTimeMode === 'now' }"
                            @click="selectedCallTimeMode = 'now'">
                            Сейчас
                        </button>
                        <button type="button" class="application-form-calltime__mode"
                            :class="{ 'application-form-calltime__mode_active': selectedCallTimeMode === 'later' }"
                            @click="selectedCallTimeMode = 'later'">
                            В другое время
                        </button>
                    </div>
                    <div v-if="selectedCallTimeMode === 'later'" class="application-form-calltime__select-wrap">
                        <select v-model="selectedTimeInterval" class="application-form-calltime__select"
                            :class="{ 'application-form-calltime__select_active': selectedTimeInterval }">
                            <option disabled value="">Выберите интервал времени</option>
                            <option v-for="slot in timeIntervals" :key="slot" :value="slot">
                                {{ slot }}
                            </option>
                        </select>
                    </div>
                </div>
                <!-- Поле ввода комментария - блок -->
                <div class="call-me-page-form__comment-input-container" v-if="!hideComment">
                    <textarea class="call-me-page-form__comment-input" placeholder="Комментарий"
                        v-model="commentValue"></textarea>
                </div>
                <!-- Согласие на обработку персональных данных - блок -->
                <p class="call-me-page-form__personal-data-processing-container">
                    <input class="call-me-page-form__personal-data-processing-checkbox" type="checkbox"
                        :checked="isCheckboxChecked" @change="handleCheckboxChange" />
                    <span class="call-me-page-form__personal-data-processing-text">Я даю <a
                            href="https://lahtaclinic.ru/agreement" target="_blank"
                            class="call-me-page-form__personal-data-processing-link">согласие</a> на обработку
                        персональных данных, ознакомлен(а) с <a class="call-me-page-form__personal-data-processing-link"
                            href="https://lahtaclinic.ru/licenses-and-documents/politika-obrabotki-i-zashity-personalnyh-dannyh/">Политикой
                            конфиденциальности</a></span>
                </p>
                <p class="call-me-page-form__checkbox-error" v-if="isCheckboxError">Необходимо дать согласие на
                    обработку персональных данных</p>
                <!-- Кнопка отправки данных - блок -->
                <div class="call-me-page-form__send-request-button-container">
                    <button class="call-me-page-form__send-request-button" type="button" @click="handleSendData">{{
                        buttonText }}
                    </button>
                </div>
                <div class="call-me-page-form__close_button hide-popup-by-click"></div>
            </form>

            <div class="call-me-page-form" v-if="showSms && challengeId && formContent.sms !== false">
                <p style="font-weight: 500;font-family: Lato;
                font-size: 16px;
                line-height: 20px;
                color: #545A66;
                margin-bottom: 1px;">
                    На номер <b>{{ telephoneNumberValue }}</b> отправлен код из 6 цифр. Введите его для
                    подтверждения заявки.
                </p>
                <br>
                <input type="text" placeholder="Код из СМС" class="call-me-page-form__name-input" v-model="smsCode"
                    autocomplete="one-time-code" inputmode="numeric" pattern="[0-9]*"
                    :class="{ 'error-sms': errorSms }">
                <br>
                <div style="font-size: small; color: red; margin-bottom: 5px; margin-top: 5px;" v-if="errorSms">Вы ввели
                    неверный код
                </div>
                <br>
                <div class="call-me-page-form__send-request-button" style="cursor: pointer" v-if="!disabledBtn"
                    @click="handleSendData">
                    Подтвердить
                </div>
                <div class="call-me-page-form__send-request-button" style="cursor: no-drop; opacity: 0.3" v-else>
                    Проверка...
                </div>

                <template v-if="timer !== 0">
                    <div style="opacity: 0.7; padding: 10px 10px 10px 0;">
                        Повторная отправка СМС возможна через {{ timer }} с.
                    </div>
                </template>
                <template v-else-if="timer === 0">
                    <div style="padding: 10px 10px 10px 0;">
                        <span style="text-decoration: underline; cursor: pointer"
                            @click="handleResendSms">Повторить</span>
                        отправку СМС
                    </div>
                </template>
            </div>

            <div class="call-me-page-form" style="padding-bottom: 40px; height: 100%;" v-if="showSms && !challengeId">
                <YandexSmartCaptcha :siteKey="captchaKey" @onSuccess="handleCaptchaSuccess" />
            </div>

            <!-- Окно, выводящееся при успехе -->
            <div class="call-me-page-success" v-show="isSuccess && !showSms">
                <div class="call-me-page-success__pic">
                </div>
                <div class="call-me-page-success__title like-h2">{{ formContent.successTitle }}</div>
                <p class="call-me-page-success__text">{{ formContent.successText }}</p>
                <div class="call-me-page-form__close_button hide-popup-by-click"></div>
            </div>
        </div>
    </div>
</template>

<script>
import { computed, defineComponent, onBeforeUnmount, ref, watch } from "vue";
import { YandexSmartCaptcha } from "@gladesinger/vue3-yandex-smartcaptcha";
import { sendData, sendSms, sendStatCalltouch, sendStatYandexMetrika, verifySms } from "../libs/inlineApplicationFormApi";

export default defineComponent({
    name: "ApplicationForm",
    components: {
        YandexSmartCaptcha
    },
    props: {
        formContent: {
            type: Object,
            required: true
        },
        site: {
            type: String,
            required: false
        },
        hideComment: {
            type: Boolean,
            default: false
        },
        buttonText: {
            type: String,
            default: "Оставить заявку"
        }
    },
    setup(props, { emit }) {
        const captchaKey = process.env.VUE_APP_SMART_CAPTCHA_KEY || process.env.VUE_SMART_CAPTCHA_KEY || "";
        const captchaToken = ref("");
        const challengeId = ref("");
        const verifiedToken = ref("");
        const mask = ref("Номер телефона");
        const nameValue = ref("");
        const telephoneNumberValue = ref("");
        const commentValue = ref(props.formContent?.comment || "");
        const isSuccess = ref(false);
        const isPhoneError = ref(false);
        const showSms = ref(false);
        const selectedCallTimeMode = ref("now");
        const selectedTimeInterval = ref("");
        const smsCode = ref("");
        const errorSms = ref(false);
        const timer = ref(60);
        const disabledBtn = ref(false);
        const isCheckboxChecked = ref(false);
        const isCheckboxError = ref(false);
        const intervalId = ref(null);
        const moscowTimeIntervalId = ref(null);

        const subject = computed(() => props.formContent?.formTitle || "Заявка");
        const timeIntervals = computed(() => {
            const intervals = [];
            for (let hour = 0; hour < 24; hour += 2) {
                const from = String(hour).padStart(2, "0");
                const to = String((hour + 2) % 24).padStart(2, "0");
                intervals.push(`${from}:00-${to}:00`);
            }
            return intervals;
        });
        const showCallTimeFields = ref(false);

        const updateCallTimeVisibility = () => {
            const moscowHour = Number(
                new Intl.DateTimeFormat("ru-RU", {
                    timeZone: "Europe/Moscow",
                    hour: "2-digit",
                    hour12: false
                }).format(new Date())
            );

            showCallTimeFields.value = moscowHour >= 22 || moscowHour < 7;
        };

        const clearIntervalSafe = () => {
            if (intervalId.value) {
                clearInterval(intervalId.value);
                intervalId.value = null;
            }
        };

        const resetForm = () => {
            captchaToken.value = "";
            challengeId.value = "";
            verifiedToken.value = "";
            mask.value = "Номер телефона";
            nameValue.value = "";
            telephoneNumberValue.value = "";
            commentValue.value = props.formContent?.comment || "";
            isSuccess.value = false;
            isPhoneError.value = false;
            showSms.value = false;
            selectedCallTimeMode.value = "now";
            selectedTimeInterval.value = "";
            smsCode.value = "";
            errorSms.value = false;
            timer.value = 60;
            disabledBtn.value = false;
            isCheckboxChecked.value = false;
            isCheckboxError.value = false;
            clearIntervalSafe();
        };

        const handleHidePopup = (event) => {
            const CLASS_TO_RUN = "hide-popup-by-click";
            if (event && event.target && !event.target.classList.contains(CLASS_TO_RUN)) return;

            emit("hidePopup", null);
            resetForm();
        };

        const validatePhone = () => !!telephoneNumberValue.value && telephoneNumberValue.value.length > 0;
        const validateCheckbox = () => isCheckboxChecked.value;

        const handleCheckboxChange = (event) => {
            isCheckboxChecked.value = !!event?.target?.checked;
            if (isCheckboxChecked.value) {
                isCheckboxError.value = false;
            }
        };

        const handleUnsetDefaultPhone = () => {
            if (telephoneNumberValue.value.length === 0) {
                mask.value = "Номер телефона";
            }
        };

        const handleEatenNums = () => {
            const lettersArr = telephoneNumberValue.value.split("");
            if (["7", "8"].includes(lettersArr[4])) {
                telephoneNumberValue.value = telephoneNumberValue.value.substr(0, 4);
            }
        };

        const handleSetDefaultPhone = () => {
            if (telephoneNumberValue.value.length === 0) {
                mask.value = "+7 (___) ___ __ __";
            }
        };

        const handleHidePhoneError = () => {
            isPhoneError.value = false;
        };

        const handlePhoneInput = () => {
            handleHidePhoneError();
            handleEatenNums();
        };

        const startDecrement = () => {
            timer.value = 60;
            clearIntervalSafe();
            intervalId.value = setInterval(() => {
                timer.value = timer.value - 1;
                if (timer.value === 0) {
                    clearIntervalSafe();
                }
            }, 1000);
        };

        const handleSendSms = async () => {
            if (!captchaToken.value || !telephoneNumberValue.value) {
                showSms.value = true;
                return;
            }
            try {
                disabledBtn.value = true;
                const response = await sendSms({
                    token: captchaToken.value,
                    phone: telephoneNumberValue.value,
                    purpose: "order",
                    referrer: window.location.href
                });
                challengeId.value = response?.challengeId || "";
                verifiedToken.value = "";
                showSms.value = true;
                const cooldown = response?.cooldown || 60;
                timer.value = cooldown;
                startDecrement();
            } catch (error) {
                console.error("sendSms error:", error);
            } finally {
                disabledBtn.value = false;
            }
        };

        const pushDataLayer = () => {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: "formGTM"
            });
        };

        const handleSendStatCalltouch = async (payload) => {
            let sessionId = "";
            if (typeof window.ct === "function") {
                try {
                    sessionId = window.ct("calltracking_params", "3e2a5ywa").sessionId;
                } catch (error) {
                    console.warn("Calltouch sessionId error:", error);
                }
            }
            await sendStatCalltouch({
                ...payload,
                site: props?.site,
                page: window.location.href,
                sessionId
            });
        };

        const handleVerifySms = async () => {
            if (!challengeId.value || !smsCode.value) {
                errorSms.value = true;
                return;
            }
            try {
                disabledBtn.value = true;
                const response = await verifySms({
                    challengeId: challengeId.value,
                    sms: smsCode.value
                });
                const success = response?.success === true;
                if (success) {
                    verifiedToken.value = response?.verifiedToken || "";
                    errorSms.value = false;
                } else {
                    errorSms.value = true;
                }
                return success;
            } catch (error) {
                console.error("verifySms error:", error);
                errorSms.value = true;
                return false;
            } finally {
                disabledBtn.value = false;
            }
        };

        const handleSendData = async () => {
            if (!validatePhone()) {
                isPhoneError.value = true;
                return;
            }

            if (!validateCheckbox()) {
                isCheckboxError.value = true;
                return;
            }

            // Если нет подтвержденного токена, запускаем капчу/SMS
            if (!verifiedToken.value) {
                showSms.value = true;
                if (!captchaToken.value) {
                    return;
                }
                if (!challengeId.value) {
                    await handleSendSms();
                    return;
                }
                const verified = await handleVerifySms();
                if (!verified) {
                    return;
                }
            }

            try {
                disabledBtn.value = true;
                const response = await sendData({
                    subject: subject.value,
                    name: nameValue.value,
                    phone: telephoneNumberValue.value,
                    token: verifiedToken.value,
                    sms: smsCode.value,
                    comment: commentValue.value,
                    time: selectedCallTimeMode.value === "later" ? selectedTimeInterval.value : "Сейчас",
                    target: props.formContent?.formTarget,
                    page: window.location.href,
                    title: document.title
                });

                if (response?.success === true) {
                    isSuccess.value = true;
                    showSms.value = false;
                    errorSms.value = false;
                    pushDataLayer();
                    await handleSendStatCalltouch({
                        fio: nameValue.value,
                        phoneNumber: telephoneNumberValue.value,
                        email: "",
                        target: props.formContent?.formTarget
                    });
                    sendStatYandexMetrika();
                } else if (response?.success === false && response?.message === "error_sms") {
                    isSuccess.value = false;
                    errorSms.value = true;
                    showSms.value = true;
                } else {
                    isSuccess.value = false;
                }
            } catch (error) {
                console.error("sendData error:", error);
            } finally {
                disabledBtn.value = false;
            }
        };

        const handleCaptchaSuccess = async (newToken) => {
            captchaToken.value = newToken;
            showSms.value = true;
            challengeId.value = "";
            verifiedToken.value = "";
            await handleSendSms();
        };

        const handleResendSms = async () => {
            captchaToken.value = "";
            challengeId.value = "";
            verifiedToken.value = "";
            smsCode.value = "";
            errorSms.value = false;
            showSms.value = true;
        };

        watch(
            () => props.formContent,
            (newVal) => {
                if (newVal && typeof newVal.comment !== "undefined") {
                    commentValue.value = newVal.comment;
                }
            },
            { deep: true }
        );

        onBeforeUnmount(() => {
            clearIntervalSafe();
            if (moscowTimeIntervalId.value) {
                clearInterval(moscowTimeIntervalId.value);
                moscowTimeIntervalId.value = null;
            }
        });

        updateCallTimeVisibility();
        moscowTimeIntervalId.value = setInterval(updateCallTimeVisibility, 60 * 1000);

        return {
            captchaKey,
            captchaToken,
            challengeId,
            verifiedToken,
            mask,
            nameValue,
            telephoneNumberValue,
            commentValue,
            isSuccess,
            isPhoneError,
            showSms,
            selectedCallTimeMode,
            selectedTimeInterval,
            showCallTimeFields,
            timeIntervals,
            smsCode,
            errorSms,
            timer,
            disabledBtn,
            isCheckboxChecked,
            isCheckboxError,
            handleCheckboxChange,
            handleHidePopup,
            handlePhoneInput,
            handleUnsetDefaultPhone,
            handleSetDefaultPhone,
            handleSendData,
            handleCaptchaSuccess,
            handleResendSms
        };
    }
});
</script>
